import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Badge, Spinner, Button, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { 
  fetchAllergyActionPlans,
  selectPlans, 
  selectMeta, 
  selectLoading, 
  selectError
} from '../../../../store/allergyActionPlan/allergyActionPlanSlice';
import AllergyActionPlanListComp from '../../../../components/registrationPacket/AllergyActionPlanListComp';

const AllergyActionPlanList = () => {
  

  useEffect(() => {
    
  }, []);


  return (
    <Container>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <div className="header-title">
                <h4 className="card-title">Individual Allergy/Anaphylaxis Action Plans</h4>
              </div>
              <Link to="/dashboard/allergy-action-plan/add">
                <Button variant="primary" size="sm">
                  <i className="icon material-symbols-outlined me-1" style={{verticalAlign: 'middle'}}>add</i>
                  Create New Plan
                </Button>
              </Link>
            </Card.Header>
            <Card.Body>
              <AllergyActionPlanListComp />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AllergyActionPlanList;
